module.exports = __webpack_public_path__ + "assets/alerts_black.566cc772.svg";